import {
  Backdrop,
  Button,
  Card,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDetails,
  receiveProfileData,
  reset,
} from "../../redux/profile/profileSlice";
import { useNavigate } from "react-router-dom";
import { ServiceApi } from "../../services/index.service";
import { useSnackbar } from "notistack";
import { LocalStore, RemoveLocalStore } from "../../utils/storage";
import { setStorePermissions, storeSet } from "../../redux/store/storeSlice";

const Login = () => {
  const [lognDetails, setLoginDetails] = useState({
    UserName: "",
    Password: "",
  });
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  console.log(profile);
  useEffect(() => {
    if (profile) {
      navigate("/treatteam");
    }
  }, [profile]);

  const handleChange = (name, value) => {
    setLoginDetails({ ...lognDetails, [name]: value });
  };
  const service = new ServiceApi();
  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmit(true);
    if (!lognDetails?.UserName || !lognDetails?.Password) {
      return;
    }
    // dispatch(
    //   getUserDetails({
    //     preferred_username: lognDetails?.UserName,
    //   })
    // );
    const req = {
      UserName: lognDetails?.UserName,
      Password: lognDetails?.Password,
    };
    dispatch(storeSet(""));
    dispatch(setStorePermissions(null))
    try {
      setLoading(true);
      const res = await service.SignInUser(req);
      if (res?.statusCode === 200) {
        const obj = {
          ...res?.data?.user_roles,
          permissions: res?.data.permissions,
          token: res?.token
        };
        dispatch(receiveProfileData(obj));
        dispatch(getUserDetails({ preferred_username: obj?.user_name }))
        LocalStore("lognDetails", req);
        LocalStore("userDetails", obj);
      }
    } catch (error) {
      RemoveLocalStore("userDetails");
      dispatch(reset(null));
      enqueueSnackbar(error?.response?.data?.message || "Login failed, please try again.", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "warning",
        autoHideDuration: 3000
      });
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper pt-16 mt-16">
      <div className="flex justify-center">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        <Card
          variant="outlined"
          className="bg-white"
          style={{ width: "450px" }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <div className="flex items-center justify-center mt-3">
                <div className="flex flex-shrink-0 items-center">
                  <img
                    className="block h-10 w-auto lg:hidden"
                    src="../../assets/images/logo.png"
                    alt="Ritas Logo"
                  />
                  <img
                    className="hidden h-12 w-auto lg:block"
                    src="../../assets/images/logo.png"
                    alt="Ritas Logo"
                  />
                </div>
              </div>
            </Grid>
            <form onSubmit={handleLogin} style={{width:'100%',display:'flex',flexDirection:'column',justifyContent:'center'}}>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl
                className="flex items-center justify-center"
                sx={{ m: 2, minWidth: "90%", border: "none" }}
              >
                <TextField
                  size="small"
                  label="User Name"
                  id="UserName"
                  name="UserName"
                  variant="outlined"
                  required
                  fullWidth
                  value={lognDetails?.UserName}
                  onChange={(e) => {
                    handleChange("UserName", e.target.value);
                  }}
                />
                {submit && !lognDetails?.UserName && (
                  <FormHelperText
                    className="flex justify-start"
                    style={{ width: "100%", color: "red" }}
                  >
                    {"User Name is required"}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl
                className="flex items-center justify-center"
                sx={{ m: 2, minWidth: "90%", border: "none" }}
              >
                <TextField
                  size="small"
                  type="password"
                  label="Password"
                  variant="outlined"
                  fullWidth
                  required
                  id="Password"
                  name="Password"
                  value={lognDetails?.Password}
                  onChange={(e) => {
                    handleChange("Password", e.target.value);
                  }}
                />
                {submit && !lognDetails?.Password && (
                  <FormHelperText
                    className="flex justify-start"
                    style={{ width: "100%", color: "red" }}
                  >
                    {"Password is required"}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl
                className="flex items-center justify-center"
                sx={{ m: 2,mb:4, minWidth: "90%", border: "none" }}
              >
                <Button
                  type="submit"
                  variant="outlined"
                  fullWidth
                  // onClick={() => handleLogin()}
                >
                  Login
                </Button>
              </FormControl>
            </Grid>
            </form>
          </Grid>
        </Card>
      </div>
    </div>
  );
};

export default Login;
